import React, { useEffect, useState } from 'react';



function AttendanceSummery() {
     const token = sessionStorage.getItem("token") || localStorage.getItem("token");
     const BASE_URL = process.env.REACT_APP_BASE_URL;
     const [employees, setEmployees] = useState([]);

     const [attendance, setAttendance] = useState([]);
     const [selectedMonth, setSelectedMonth] = useState();
     const [employeeInputValue, setEmployeeInputValue] = useState("");
     const selectedEmployee = sessionStorage.getItem("user_code");


     const fetchAttendance = async () => {
          try {
               const url = `${BASE_URL}/getEmployeeAttendance`;
               const payload = {
                    employee_code: selectedEmployee,
                    selectedMonth: selectedMonth
               };
               const response = await fetch(url, {
                    method: 'POST',
                    headers: {
                         'Content-Type': 'application/json',
                         'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload)
               });
               const json = await response.json();

               if (json.status && json.data) {
                    setAttendance(json.data); // <-- set to object, not array
               } else {
                    setAttendance({});
               }
          } catch (err) {
               console.error('Error fetching attendance:', err);
               setAttendance([]);
          }
     };



     useEffect(() => {
          if (selectedMonth && selectedEmployee && typeof selectedMonth === "string" && selectedMonth.includes("-")) {
               const [year, month] = selectedMonth.split("-");
               fetchAttendance(year, month);
          }
     }, [selectedMonth]);

     const handleStatusChange = (id, newStatus) => {
          setAttendance(attendance =>
               attendance.map(emp =>
                    emp.id === id ? { ...emp, status: newStatus } : emp
               )
          );
     };

     return (
          <div style={{ padding: '2rem' }}>
               <h3>Attendance</h3>
               {/* make employee selection dropdown, select month input,   */}
               <div style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>

                    <div style={{ maxWidth: "150px", marginBottom: "16px" }}>
                         <input type="month"
                              className="form-control form-control-sm"
                              id="monthSelect"
                              placeholder="Select Month"
                              min={"2025-08"}
                              value={selectedMonth}
                              onChange={e => setSelectedMonth(e.target.value)}
                         />
                    </div>
               </div>

               <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                         <tr>
                              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Date</th>
                              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Day</th>
                              <th style={{ border: '1px solid #ccc', padding: '8px' }}>In</th>
                              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Out</th>
                              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Shift</th>
                              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Late Mark</th>
                              <th style={{ border: '1px solid #ccc', padding: '8px' }}>Status</th>

                         </tr>
                    </thead>
                    <tbody>
                         {attendance.days && attendance.days.map(day => {
                              const dateObj = new Date(day.date);
                              const dd = String(dateObj.getDate()).padStart(2, "0");
                              const mm = String(dateObj.getMonth() + 1).padStart(2, "0");
                              const yyyy = dateObj.getFullYear();
                              const formattedDate = `${dd}-${mm}-${yyyy}`;
                              const roster = attendance.duty_roster?.find(r => r.attendance_date === day.date);

                              // Defensive: If roster is undefined, skip shift logic
                              const shiftName = roster?.ShiftName || "-";
                              const shiftStart = roster?.ShiftStart;
                              const shiftEnd = roster?.ShiftEnd;
                              const fullDayMinutes = parseInt(roster?.WorkingsHoursToBeConsiderdFullDay || "0", 10);
                              const halfDayMinutes = parseInt(roster?.WorkingsHoursToBeConsiderdHalfDay || "0", 10);

                              const punchIn = day.punch_in ? new Date(day.punch_in) : null;
                              const punchOut = day.punch_out ? new Date(day.punch_out) : null;

                              let lateMark = "-";
                              if (
                                   roster &&
                                   typeof shiftStart === "string" &&
                                   shiftStart &&
                                   shiftStart.includes(":") &&
                                   punchIn
                              ) {
                                   const [h, m, s] = shiftStart.split(":").map(Number);
                                   const shiftStartDate = new Date(day.date + "T" + shiftStart);
                                   shiftStartDate.setMinutes(shiftStartDate.getMinutes() + 10); // 10 min grace
                                   if (punchIn > shiftStartDate) {
                                        lateMark = "Late";
                                   } else {
                                        lateMark = "On Time";
                                   }
                              }

                              const holidayObj = attendance.holidays?.find(h => h.holiday_date === day.date);

                              let status = "-";
                              if (holidayObj) {
                                   status = holidayObj.holiday_name;
                              } else if (punchIn && punchOut) {
                                   if (
                                        roster &&
                                        typeof shiftEnd === "string" &&
                                        shiftEnd &&
                                        shiftEnd.includes(":")
                                   ) {
                                        const [eh, em, es] = shiftEnd.split(":").map(Number);
                                        const shiftEndDate = new Date(day.date + "T" + shiftEnd);
                                        shiftEndDate.setMinutes(shiftEndDate.getMinutes() - 10); // 10 min grace before shift end
                                        if (punchOut < shiftEndDate) {
                                             status = "Early Going";
                                        } else {
                                             const workedMinutes = Math.round((punchOut - punchIn) / (1000 * 60));
                                             if (workedMinutes >= fullDayMinutes) {
                                                  status = "Present";
                                             } else if (workedMinutes >= halfDayMinutes) {
                                                  status = "Half Day";
                                             } else {
                                                  status = "Absent";
                                             }
                                        }
                                   } else {
                                        const workedMinutes = Math.round((punchOut - punchIn) / (1000 * 60));
                                        if (workedMinutes >= fullDayMinutes) {
                                             status = "Present";
                                        } else if (workedMinutes >= halfDayMinutes) {
                                             status = "Half Day";
                                        } else {
                                             status = "Absent";
                                        }
                                   }
                              } else {
                                   status = "Absent";
                              }
                              if (roster?.custom_weekoff_date) {
                                   status = "Weekoff";
                              }

                              return (
                                   <tr key={day.date}>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{formattedDate}</td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                             {["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"][dateObj.getDay()]}
                                        </td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                             {day.punch_in ? new Date(day.punch_in).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : "-"}
                                        </td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>
                                             {day.punch_out ? new Date(day.punch_out).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }) : "-"}
                                        </td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px' }}>{shiftName}</td>
                                        <td style={{ border: '1px solid #ccc', padding: '8px', color: lateMark === "Late" ? "red" : "inherit" }}>
                                             {lateMark === "Late" ? "Late" : ""}
                                        </td>
                                        <td
                                             style={{
                                                  border: '1px solid #ccc',
                                                  padding: '8px',
                                                  color:
                                                       status === "Present" ? "green" :
                                                            status === "Half Day" ? "orange" :
                                                                 status === "Weekoff" ? "blue" :
                                                                      status === "Absent" ? "red" :
                                                                           "inherit"
                                             }}
                                        >
                                             {status}
                                        </td>
                                   </tr>
                              );
                         })}
                    </tbody>
               </table>
          </div>
     );
}

export default AttendanceSummery;